import { useEffect, useState } from "react";
import { api } from "@/api";
import { TrendingUp } from "lucide-react";
import CountUp from "./CountUp";

/**
 * Iter99 — Widget Trafic : 4 stats animées + top 3 sources.
 * Pas de liens, pas d'actions cliquables.
 */
export default function TrafficWidget() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/dashboard/traffic")
      .then((r) => setData(r.data))
      .catch(() => setData(null))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="text-center text-gray-300 text-sm py-4">·</div>;
  if (!data) return null;

  return (
    <div className="space-y-3 animate-fade-in" data-testid="widget-traffic">
      <div className="grid grid-cols-2 gap-2">
        <Stat label="Total visites" value={data.total_visits} testId="traffic-total-visits" />
        <Stat label="Visites 7 jours" value={data.visits_7d} accent="cyan" testId="traffic-visits-7d" />
        <Stat label="Total formulaires" value={data.total_forms} testId="traffic-total-forms" />
        <Stat label="Formulaires 7 jours" value={data.forms_7d} accent="emerald" testId="traffic-forms-7d" />
      </div>
      {data.sources && data.sources.length > 0 && (
        <div>
          <div className="text-[11px] uppercase text-gray-500 mb-1.5 flex items-center gap-1">
            <TrendingUp className="w-3 h-3" /> Top sources
          </div>
          <ul className="space-y-1">
            {data.sources.slice(0, 3).map((s, i) => (
              <li
                key={i}
                className="flex items-center justify-between text-xs px-2 py-1.5 bg-gray-50 rounded"
                data-testid={`widget-traffic-source-${i}`}
              >
                <span className="truncate flex items-center gap-1.5 text-gray-700">
                  <span className="text-[10px] font-bold text-cyan-600">#{i + 1}</span>
                  <span className="truncate">
                    {s.source.startsWith("http") ? new URL(s.source).hostname : s.source}
                  </span>
                </span>
                <span className="font-semibold text-gray-900">
                  <CountUp value={s.count} />
                </span>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}

function Stat({ label, value, accent, testId }) {
  const cls =
    accent === "cyan" ? "text-cyan-600" :
    accent === "emerald" ? "text-emerald-600" :
    "text-gray-900";
  return (
    <div className="bg-gray-50 rounded-lg px-3 py-2">
      <div className="text-[10px] uppercase text-gray-500">{label}</div>
      <div className={`text-xl font-bold ${cls}`}>
        <CountUp value={value ?? 0} testId={testId} />
      </div>
    </div>
  );
}
